export default __webpack_public_path__ + "static/media/0x3809dcdd5dde24b37abe64a5a339784c3323c44f.da85e572.png";